import {
  transformCurrencyAmountDto,
  transformCurrencyAmountDtoOrString,
} from '@marketplace-web/domain/currency-data'
import { getItemThumbnail } from '@marketplace-web/shared/item-photo-data'

import {
  BundleItemPhotoDto,
  BundleItemPhotoModel,
  BundleOfferDto,
  BundleOfferModel,
  BundleOrderDto,
  BundleOrderModel,
  BundlePackageSizeDto,
  BundlePackageSizeModel,
  BundleSellerDto,
  BundleSellerModel,
  BundleTransactionDto,
  BundleTransactionItemDto,
  BundleTransactionItemModel,
  BundleTransactionModel,
} from '../types/bundle-transaction'

const transformBundlePackageSizeDto = ({
  code,
  custom,
  name,
  description,
  education_text,
  format_description,
  id,
  standard,
  title,
  weight_description,
  image,
}: BundlePackageSizeDto): BundlePackageSizeModel => ({
  code,
  custom,
  name,
  description,
  educationText: education_text,
  formatDescription: format_description,
  id,
  standard,
  title,
  weightDescription: weight_description,
  image,
})

const transformBundleItemPhotoDto = (photo: BundleItemPhotoDto): BundleItemPhotoModel => ({
  url: photo.url,
  thumbnails: photo.thumbnails,
  isMain: photo.is_main,
  imageNo: photo.image_no,
})

const transformBundleItemPhotoDtos = (
  photos: Array<BundleItemPhotoDto>,
): Array<BundleItemPhotoModel> => photos.map(transformBundleItemPhotoDto)

const transformTransactionItemDto = (
  item: BundleTransactionItemDto,
): BundleTransactionItemModel => ({
  id: item.id,
  title: item.title,
  size: item.size_title || '',
  status: item.status,
  price: transformCurrencyAmountDto(item.price),
  thumbnailUrl: getItemThumbnail(item.photos),
  url: item.url,
  photos: transformBundleItemPhotoDtos(item.photos),
})

export const transformBundleTransactionItemDtos = (
  items: Array<BundleTransactionItemDto>,
): Array<BundleTransactionItemModel> => items.map(transformTransactionItemDto)

const transformBundleOrder = (order: BundleOrderDto): BundleOrderModel => ({
  items: transformBundleTransactionItemDtos(order.items),
  itemIds: order.item_ids,
  title: order.title,
  reserved: order.reserved,
  packageSize: order.package_size ? transformBundlePackageSizeDto(order.package_size) : null,
})

const transformBundleSeller = (seller: BundleSellerDto): BundleSellerModel => ({
  id: seller.id,
  business: seller.business,
})

const transformBundleOfferDto = ({ id, price, currency }: BundleOfferDto): BundleOfferModel => ({
  id,
  price: transformCurrencyAmountDtoOrString(price, currency),
})

export const transformBundleTransaction = ({
  id,
  order,
  user_msg_thread_id,
  item_id,
  items_count,
  offer,
  seller,
}: BundleTransactionDto): BundleTransactionModel => ({
  id,
  order: transformBundleOrder(order),
  conversationId: user_msg_thread_id,
  itemId: item_id,
  itemsCount: items_count,
  offer: transformBundleOfferDto(offer),
  seller: seller ? transformBundleSeller(seller) : null,
})
